// Carregar estado atual (GET)
export const PICKUP_VALIDATION_LOAD = 'PICKUP_VALIDATION_LOAD';
export const PICKUP_VALIDATION_LOAD_SUCCESS = 'PICKUP_VALIDATION_LOAD_SUCCESS';
export const PICKUP_VALIDATION_LOAD_FAILURE = 'PICKUP_VALIDATION_LOAD_FAILURE';

// Iniciar sessão (POST)
export const PICKUP_VALIDATION_START = 'PICKUP_VALIDATION_START';
export const PICKUP_VALIDATION_START_SUCCESS =
  'PICKUP_VALIDATION_START_SUCCESS';
export const PICKUP_VALIDATION_START_FAILURE =
  'PICKUP_VALIDATION_START_FAILURE';

// Verificar nome+placa
export const PICKUP_VALIDATION_VERIFY = 'PICKUP_VALIDATION_VERIFY';
export const PICKUP_VALIDATION_VERIFY_SUCCESS =
  'PICKUP_VALIDATION_VERIFY_SUCCESS';
export const PICKUP_VALIDATION_VERIFY_FAILURE =
  'PICKUP_VALIDATION_VERIFY_FAILURE';

// Liberação pelo suporte Viddy (sessão bloqueada)
export const PICKUP_VALIDATION_SUPPORT_RELEASE =
  'PICKUP_VALIDATION_SUPPORT_RELEASE';
export const PICKUP_VALIDATION_SUPPORT_RELEASE_SUCCESS =
  'PICKUP_VALIDATION_SUPPORT_RELEASE_SUCCESS';
export const PICKUP_VALIDATION_SUPPORT_RELEASE_FAILURE =
  'PICKUP_VALIDATION_SUPPORT_RELEASE_FAILURE';

// Liberar fisicamente (release final)
export const PICKUP_VALIDATION_RELEASE = 'PICKUP_VALIDATION_RELEASE';
export const PICKUP_VALIDATION_RELEASE_SUCCESS =
  'PICKUP_VALIDATION_RELEASE_SUCCESS';
export const PICKUP_VALIDATION_RELEASE_FAILURE =
  'PICKUP_VALIDATION_RELEASE_FAILURE';

// Cancelar sessão manualmente
export const PICKUP_VALIDATION_CANCEL = 'PICKUP_VALIDATION_CANCEL';
export const PICKUP_VALIDATION_CANCEL_SUCCESS =
  'PICKUP_VALIDATION_CANCEL_SUCCESS';
export const PICKUP_VALIDATION_CANCEL_FAILURE =
  'PICKUP_VALIDATION_CANCEL_FAILURE';

// Upload de foto da retirada
export const PICKUP_VALIDATION_UPLOAD_PHOTO = 'PICKUP_VALIDATION_UPLOAD_PHOTO';
export const PICKUP_VALIDATION_UPLOAD_PHOTO_SUCCESS =
  'PICKUP_VALIDATION_UPLOAD_PHOTO_SUCCESS';
export const PICKUP_VALIDATION_UPLOAD_PHOTO_FAILURE =
  'PICKUP_VALIDATION_UPLOAD_PHOTO_FAILURE';

// Evento Echo: entregador acionou coleta no app do parceiro
export const PICKUP_VALIDATION_DISPATCHED_RECEIVED =
  'PICKUP_VALIDATION_DISPATCHED_RECEIVED';

// Controle do modal
export const PICKUP_VALIDATION_OPEN_MODAL = 'PICKUP_VALIDATION_OPEN_MODAL';
export const PICKUP_VALIDATION_CLOSE_MODAL = 'PICKUP_VALIDATION_CLOSE_MODAL';

// Reset do estado (quando navega pra outro pedido)
export const PICKUP_VALIDATION_RESET = 'PICKUP_VALIDATION_RESET';
